import { createContext, ReactNode, useEffect, useState } from "react";
import { ICoord } from "../@types/GoogleMaps/ICoord";
import { IBatch } from "../@types/API/IBatches";

type ICustomBatch = {
  initials: string;
  coords: ICoord;
  id: string;
  farmId: string;
  areaId: string;
  visible: boolean;
  currentMicroArea?: number;
};

type DataContext = {
  microAreas: IMicroArea[];
  setMicroAreas: (microArea: IMicroArea[]) => void;
  batches: IBatch[];
  setBatches: (batches: IBatch[]) => void;
  customBatches: ICustomBatch[];
  setCustomBatches: (batches: ICustomBatch[]) => void;
};

type DataProviderProps = {
  children: ReactNode;
};

const DataContext = createContext({} as DataContext);

function DataProvider({ children }: DataProviderProps) {
  const [microAreas, setMicroAreas] = useState<IMicroArea[]>([]);
  const [batches, setBatches] = useState<IBatch[]>([]);
  const [customBatches, setCustomBatches] = useState<ICustomBatch[]>([]);

  return (
    <DataContext.Provider
      value={{
        microAreas,
        setMicroAreas,
        batches,
        setBatches,
        customBatches,
        setCustomBatches
      } as DataContext}
    >
      {children}
    </DataContext.Provider>
  );
}

export { DataContext, DataProvider };
